var ChatterBarView = require('chatterbarview');


var UpperChatterBarView = ChatterBarView.extend({
    buttonText: '↑',
    buttonTitle: 'Scroll to last read',
    className: ChatterBarView.prototype.className + ' bufferAboveExtras',
    render: function () {
        var dismiss = $('<span class="extrasDismiss bufferAboveExtrasDismiss">')
            .text('Mark as read (Esc)');
        $(this.el).append(dismiss);
        
        ChatterBarView.prototype.render.apply(this, arguments);
        
        return this;
    },
    update: function (upperMessage) {
        if (!upperMessage) {
            return null;
        }
        
        if (this.model.isMessageUnseen(upperMessage)) {
            // Clear highlights from upper visible till the bottom seen message
            var remainder = this.model.clearUnseenHighlightsAfter(upperMessage);
            this.renderMentions(remainder);

            if (this.model.getLastSeen()) {
                // Gets the difference between the upper visible and last seen message
                var seenMessage = this.model.getLastSeenMessage();
                var linesAgo;
                if (seenMessage) {
                    if (this.model.countMessagesBetween(seenMessage, upperMessage) > 100) {
                        linesAgo = true;
                    } else {
                        linesAgo = this.model.countImportantMessagesBetween(seenMessage, upperMessage);
                    }
                } else {
                    linesAgo = true; // undefined number of messages
                }
                // Render the chatter bar if there unseen important messages
                if (linesAgo) {
                    this.renderChatter(this.model.getLastSeenDate(), linesAgo);
                    return true;
                }
            }
        }
        // Last seen is later than upper message, or no unseen important messages, hide
        this.hide();
        return false;
    }
});


module.exports = UpperChatterBarView;



//////////////////
// WEBPACK FOOTER
// ./app/src/view/upperchatterbarview.js
// module id = 9lob
// module chunks = 1